// @ts-expect-error untyped module
import { OfficeLocationType } from '../../../constants/search/Filters';
// @ts-expect-error untyped module
import { getUserFirstName } from '../../../selectors/auth';
// @ts-expect-error untyped module
import { getCertifications } from '../../../selectors/certifications';
// @ts-expect-error untyped module

// @ts-expect-error untyped module
import { getHasFilters } from '../../../utils/filters';
// @ts-expect-error untyped module
import { push } from '../../../utils/history';
// @ts-expect-error untyped module
import { translateFilterValue } from '../../../utils/i18n';
// @ts-expect-error untyped module
import ResultCard from '../../results/ResultCard';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { H1 } from 'foundations-components/transitional/components/H1';
import { registerQuery, useQuery } from 'data-fetching-client';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getCredentialDisplayName } from 'marketplace-ui-common/utils/credentials';
import { ProfileListing } from 'marketplace-ui-solutions-core/records/ProfileListing';
import { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { marketplaceSearchProfilesMulti } from '../../../clients/marketplaceSearchClient';
import * as FilterKey from '../../../constants/search/FilterKey';
import { getAccreditations } from '../../../selectors/accreditations';
import { getIntegrations } from '../../../slices/integrationsSlice';
import { getServices } from '../../../slices/serviceCatalogSlice';
import { clearRecentActivity, getRecentActivity } from '../../../utils/homepage';
import { fromFilterStateToLocation, fromFilterStateToQuery } from '../../../utils/storefrontFilters';
import FindPartnerWizard from './FindPartnerWizard';
import { View as FoundationsView } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GET_PROFILES = registerQuery({
  args: ['queries'],
  fieldName: 'profiles',
  fetcher: ({
    queries
  }) => {
    return marketplaceSearchProfilesMulti(queries);
  }
});
export default function FindPartnerWizardResultsCarousel({
  isMobile
}) {
  const lang = getLang();
  const firstName = useSelector(getUserFirstName);
  const catalogServices = useSelector(getServices);
  const accreditations = useSelector(getAccreditations);
  const certifications = useSelector(getCertifications);
  const integrations = useSelector(getIntegrations);
  const [showFindPartnerWizard, setShowFindPartnerWizard] = useState(false);
  const [results, setResults] = useState([]);
  const relevantFilters = useMemo(() => {
    const recentActivity = getRecentActivity();
    const questionnaireFilters = recentActivity && recentActivity.questionnaireFilters;
    const filters = recentActivity && recentActivity.filters;
    if (recentActivity && recentActivity.type === 'questionnaire') {
      return getHasFilters(questionnaireFilters) ? questionnaireFilters : filters;
    }
    return filters;
  }, []);
  const profileNames = useMemo(() => {
    const recentActivity = getRecentActivity();
    return recentActivity && recentActivity.viewedProfiles || [];
  }, []);
  const {
    data: profilesData
  } = useQuery(GET_PROFILES, {
    variables: {
      queries: [...profileNames.map(name => ({
        nameSearch: name,
        callingUserLanguage: lang
      })), relevantFilters && Object.assign({}, fromFilterStateToQuery(Object.assign({}, relevantFilters)), {
        limit: 15,
        callingUserLanguage: lang
      }) || {}]
    }
  });
  const handleViewAllClick = useCallback(() => {
    const recentActivity = getRecentActivity();
    const {
      pathname,
      search
    } = fromFilterStateToLocation(relevantFilters || {}, catalogServices);
    const isQuestionnaireActivity = recentActivity && recentActivity.type === 'questionnaire';
    push({
      pathname,
      search: search.concat(isQuestionnaireActivity ? '&ref=questionnaire' : '')
    });
  }, [catalogServices, relevantFilters]);
  useEffect(() => {
    const recentActivity = getRecentActivity();
    if (recentActivity) {
      const profileIdList = [];
      const profiles = profilesData && profilesData.profiles && profilesData.profiles.reduce((finalArr, searchResp) => {
        const deDupedProfiles = searchResp.items.filter(profile => profileIdList.indexOf(profile.id) === -1);
        if (searchResp.items.length === 1) {
          searchResp.items.forEach(profile => profileIdList.push(profile.id));
        }
        return [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
        ...finalArr, ...deDupedProfiles];
      }, []);
      setResults(profiles || []);
    }
  }, [profilesData]);
  const remainingFiltersCountText = useCallback(count => {
    return count && /*#__PURE__*/_jsx(FormattedMessage, {
      "data-test-id": "remaining-filter-count",
      message: `ecosystem-marketplace-solutions-ui.homepage.resultsCarousel.${count === 1 ? 'remainingFiltersCountOne' : 'remainingFiltersCountMulti'}`,
      options: {
        count
      }
    }) || null;
  }, []);
  const renderedFilterString = useMemo(() => {
    const recentActivity = getRecentActivity();
    if (!relevantFilters || !getHasFilters(relevantFilters)) {
      return null;
    }
    const filterCountLimit = 4;
    let selectedFilters = []; // full list of translated filter names
    const filterCategoryPriority = [FilterKey.SERVICE, FilterKey.INDUSTRY, FilterKey.COUNTRY, FilterKey.BUDGET, FilterKey.ACCREDITATION, FilterKey.LANGUAGE,
    // the order of the filters beyond this doesn't matter
    FilterKey.CERTIFICATION, FilterKey.CREDENTIAL, FilterKey.TIER, FilterKey.OFFICE_LOCATION, FilterKey.INTEGRATION];
    // translate  filters and add them to the list of selected filter values by order of priority
    filterCategoryPriority.forEach(filterKey => {
      if (typeof relevantFilters[filterKey] === 'object') {
        relevantFilters[filterKey].forEach(selectedFilter => {
          if (filterKey === FilterKey.SERVICE) {
            const service = catalogServices.find(s => s.id === selectedFilter);
            if (service && service.name) {
              selectedFilters.push(service.name);
            }
          } else if (filterKey === FilterKey.ACCREDITATION) {
            const accreditation = accreditations === null || accreditations === void 0 ? void 0 : accreditations.find(a => a.id && a.id.toString(10) === selectedFilter);
            if (accreditation) {
              selectedFilters.push(getCredentialDisplayName(accreditation, lang));
            }
          } else if (filterKey === FilterKey.CERTIFICATION) {
            const certification = certifications === null || certifications === void 0 ? void 0 : certifications.find(c => c.id && c.id.toString(10) === selectedFilter);
            if (certification) {
              selectedFilters.push(getCredentialDisplayName(certification, lang));
            }
          } else if (filterKey === FilterKey.INTEGRATION) {
            const integration = integrations.find(i => i.offeringId && i.offeringId.toString(10) === selectedFilter);
            if (integration && integration.displayName) {
              selectedFilters.push(integration.displayName);
            }
          } else {
            selectedFilters.push(translateFilterValue(filterKey, selectedFilter));
          }
        });
      } else {
        if (relevantFilters[filterKey] !== OfficeLocationType.ANY) {
          selectedFilters.push(translateFilterValue(filterKey, relevantFilters[filterKey]));
        }
      }
    });
    // just a safety check to root out any oddball translations.
    // selectedFilters can't be too large so I think this is okay
    selectedFilters = selectedFilters.filter(filterString => filterString && filterString.length);
    const remainingFilterCount = selectedFilters.length > filterCountLimit && selectedFilters.length - filterCountLimit || 0;
    let filterString = selectedFilters.slice(0, filterCountLimit).reduce((finalString, filterName) => {
      const newFinalString = /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
      finalString.concat(filterName).concat(', ');
      return newFinalString;
    }, '');
    filterString = filterString.slice(0, filterString.length - 2);
    if (recentActivity && recentActivity.filters && recentActivity.filters.search) {
      if (filterString.length) {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            "data-test-id": "carousel-subtitle-search-and-filters",
            message: "ecosystem-marketplace-solutions-ui.homepage.resultsCarousel.subtitleWithSearchAndFilters",
            options: {
              searchTerm: recentActivity.filters.search,
              filters: filterString
            }
          }), remainingFiltersCountText(remainingFilterCount)]
        });
      } else {
        return /*#__PURE__*/_jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            "data-test-id": "carousel-subtitle-search",
            message: "ecosystem-marketplace-solutions-ui.homepage.resultsCarousel.subtitleWithSearch",
            options: {
              searchTerm: recentActivity.filters.search
            }
          }), remainingFiltersCountText(remainingFilterCount)]
        });
      }
    } else {
      return filterString.length && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          "data-test-id": "carousel-subtitle-filters",
          message: "ecosystem-marketplace-solutions-ui.homepage.resultsCarousel.subtitleWithFilters",
          options: {
            filters: filterString
          }
        }), remainingFiltersCountText(remainingFilterCount)]
      }) || null;
    }
  }, [accreditations, catalogServices, certifications, integrations, lang, relevantFilters, remainingFiltersCountText]);
  const renderedProfileCards = useMemo(() => {
    return results.map(profile => {
      return /*#__PURE__*/_jsx(FoundationsView, {
        marginInlineEnd: "500",
        as: "span",
        children: /*#__PURE__*/_jsx(ResultCard, {
          width: "310px",
          result: new ProfileListing(profile)
        })
      }, profile.id);
    });
  }, [results]);
  const renderedResults = useMemo(() => {
    return /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(ScrollContainer, {
        marginBlockEnd: "1000",
        children: /*#__PURE__*/_jsx(TFlex, {
          align: "stretch",
          direction: "row",
          children: renderedProfileCards
        })
      })
    });
  }, [renderedProfileCards]);
  const clearResults = useCallback(() => {
    clearRecentActivity();
    setResults([]);
  }, []);
  const recentActivity = getRecentActivity();
  return results.length ? /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H1, {
      "data-test-id": "homepage-results-carousel",
      children: firstName ? /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.resultsCarousel.welcomeName",
        options: {
          name: firstName
        }
      }) : /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.resultsCarousel.welcome"
      })
    }), /*#__PURE__*/_jsx(Text, {
      as: "h3",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ecosystem-marketplace-solutions-ui.homepage.resultsCarousel.continueBrowsing"
      })
    }), /*#__PURE__*/_jsxs(TFlex, {
      direction: isMobile ? 'column' : 'row',
      justify: "between",
      children: [/*#__PURE__*/_jsxs(View, {
        marginInlineEnd: "200",
        paddingBlockEnd: "400",
        maxInlineSize: "75%",
        children: [renderedFilterString && /*#__PURE__*/_jsx(FoundationsView, {
          paddingInlineEnd: "200",
          as: "span",
          children: renderedFilterString
        }), recentActivity && recentActivity.type === 'questionnaire' ? /*#__PURE__*/_jsx(Button, {
          "data-test-id": "update-preferences-button",
          onClick: () => setShowFindPartnerWizard(true),
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystem-marketplace-solutions-ui.storefront.results.header.updateQuestionnaire"
          })
        }) : /*#__PURE__*/_jsx(Button, {
          "data-test-id": "clear-results-button",
          onClick: clearResults,
          use: "link",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "ecosystem-marketplace-solutions-ui.storefront.results.header.clearResults"
          })
        })]
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleViewAllClick,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "ecosystem-marketplace-solutions-ui.homepage.resultsCarousel.viewAll"
        })
      })]
    }), renderedResults, showFindPartnerWizard && /*#__PURE__*/_jsx(FindPartnerWizard, {
      onClose: () => setShowFindPartnerWizard(false),
      isMobileView: isMobile
    })]
  }) : null;
}